import { FC } from 'react';
import { QuestionSessionBodyContainerProps } from '../config';
import { observer } from 'mobx-react';
import { useReferentialQuestionContent } from '../../../../hooks/content/useReferentialQuestionContent';
import { useStores } from '../../../../hooks/useStores';

const _ContainCounsellorBio: FC<QuestionSessionBodyContainerProps> = ({
  question,
  children
}) => {
  const { question: qstore, treeNav } = useStores();
  const loading = !qstore.isReady(question._id);
  const { description, question: questionText } = useReferentialQuestionContent(question);

  const counsellorSelection = treeNav.choices.finalised
    ?.find(response => response.questionKey === 'chooseCounsellor' && response.match({ surveyId: question.survey as string }))
    ?.answers[0];

  // picture, title, gender, description
  const meta = counsellorSelection?.meta;

  return children({
    questionId: question._id,
    questionKey: question.key,
    questionType: question.type,
    questionText,
    questionDescription: description,
    loading,
    meta,
  });
};

export const ContainCounsellorBio = observer(_ContainCounsellorBio);
